"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseActivateModal = void 0;
const react_query_1 = require("@tanstack/react-query");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_toastify_1 = require("react-toastify");
const activities_1 = require("../../api/activities");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const license_1 = require("../../common/js/helper/license");
const string_1 = require("../../common/js/helper/string");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Activities_1 = __importDefault(require("../stores/Activities"));
exports.LicenseActivateModal = (0, mobx_react_1.observer)(({ license, onCancel, onDone }) => {
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const queryClient = (0, react_query_1.useQueryClient)();
    return (react_1.default.createElement("form", { onSubmit: (event) => {
            event.preventDefault();
            setIsPending(true);
            Activities_1.default.save((0, license_1.licenseActivity)(activities_1.ActivityTopic.ConsentActivateLicense, license))
                .then(onDone)
                .then(() => {
                react_toastify_1.toast.success((0, translation_1.t)('modal.license_activation.success'));
            })
                .catch(() => {
                react_toastify_1.toast.success((0, translation_1.t)('modal.license_activation.error'));
            })
                .finally(() => {
                queryClient.invalidateQueries({ queryKey: ['license', license.externalId] });
                setIsPending(false);
            });
        } },
        react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
            react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('modal.license_activation.title')),
            react_1.default.createElement("button", { className: "znd-modal__close", onClick: onCancel, disabled: isPending },
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
        react_1.default.createElement("div", { className: "modal-body znd-modal__body" },
            react_1.default.createElement("div", { className: "znd-software-license-modal__text", dangerouslySetInnerHTML: {
                    __html: (0, translation_1.t)('modal.license_activation.text', {
                        channel: AuthorizationStore_1.default.channelId,
                        product_type: (0, string_1.slugifyKey)(license.productType),
                    }),
                } })),
        react_1.default.createElement("div", { className: "modal-footer znd-modal__footer" },
            react_1.default.createElement(Button_1.default, { className: "znd-software-license-modal__button", variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: onCancel, disabled: isPending }),
            react_1.default.createElement(Button_1.default, { type: "submit", className: "znd-software-license-modal__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('modal.license_activation.submit'), disabled: isPending, loading: isPending }))));
});
